<template>
    <div class="AuthenticationStage">
        <div id="firebaseui-auth-container"></div>
    </div>
</template>

<script>
import * as firebase from 'firebase/app';
import 'firebase/auth';
import * as firebaseui from 'firebaseui';
import 'firebaseui/dist/firebaseui.css';

import EventBus from '../EventBus';

const uiConfig = {
    signInSuccessUrl: '/',
    signInOptions: [{
            provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
            requireDisplayName: true,
            signInMethod: firebase.auth.EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD,
            forceSameDevice: true,
        },
        {
            provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
            recaptchaParameters: {
                type: 'image',
                size: 'invisible',
                badge: 'bottomright',
            },
        },
    ],
    tosUrl: '/terms-of-service',
    privacyPolicyUrl() {
        window.location.assign('/privacy');
    },
};

const ui = new firebaseui.auth.AuthUI(firebase.auth());


export default {
    name: 'authentication',
    mounted() {
        ui.start('#firebaseui-auth-container', uiConfig);
    },
};
</script>

<style>
    #firebaseui-auth-container {
        margin-top: 20px;
    }
</style>
